<template>
    <div class="content-wrapper">
        <section class="content-header">
          <h1>
            Klook
          </h1>
          <ol class="breadcrumb">
            <li>
              <a @click="$router.push({ name: 'dashboard' })">
                <i class="fa fa-dashboard"></i> Dashboard
              </a>
            </li>
            <li>
              <a @click="$router.push({ name: 'klook-index' })">
                <i class="fa fa-ticket"></i> Klook
              </a>
            </li>
            <li>
              Activity
            </li>
          </ol>
      </section>

      <section class="content">
        <div class="box">
          <div class="box-header with-border">
            <div class="box-title">
              <h3>Activity</h3>
            </div>

            <a class="btn btn-default pull-right"
              @click.prevent="back">
              Back
            </a>
          </div>
          <div v-if="isLoading" style="padding:20px">
            Loading...
          </div>

          <div v-else-if="form.activity !== null" class="box-body table-responsive" style="overflow: unset;">
            <table id="table" class="table table-bordered table-striped">
              <tbody>
                <tr>
                  <th style="width: 15em">Activity ID</th>
                  <td>{{ form.activity.activity_id }}</td>
                </tr>
                <tr>
                  <th style="width: 15em">Activity Name</th>
                  <td>{{ form.activity.title }}</td>
                </tr>
                <tr>
                  <th style="width: 15em">City</th>
                  <td>{{ form.activity.city }} ({{ form.activity.city_id }})</td>
                </tr>
                <tr>
                  <th style="width: 15em">Country</th>
                  <td>{{ form.activity.country }} ({{ form.activity.country_id }})</td>
                </tr>
                <tr>
                  <th style="width: 15em">Duration</th>
                  <td>{{ form.activity.duration }}</td>
                </tr>
                <tr>
                  <th style="width: 15em">Confirmation</th>
                  <td>{{ form.activity.confirmation }}</td>
                </tr>
                <tr>
                  <th style="width: 15em">Refund</th>
                  <td>{{ form.activity.refund }}</td>
                </tr>
                <tr>
                  <th style="width: 15em">Usage</th>
                  <td style="word-break: break-word">
                    <div v-for="(usage, index) in usages"
                      :key="`usage-${index}`"
                      style="padding: 10px 0;">
                      <strong>{{ nReplace(capitalizeFirstLetter(index)) }}</strong>: {{ usage }} <br>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th style="width: 15em">Guide Lines</th>
                  <td style="word-break: break-word">
                    <div v-for="(guide, index) in guidelines"
                      :key="`guide-${index}`"
                      style="padding: 10px 0;">
                      <strong>{{ nReplace(capitalizeFirstLetter(index)) }}</strong>: {{ guide }} <br>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else style="text-align: center; margin: 2rem;">
            <h4>Activity data failed</h4>
          </div>

          <div class="box-header with-border">
            <div class="box-title">
              <h3>Product</h3>
            </div>
          </div>

          <div class="box-body">
            <div class="table-responsive">
              <table id="table" class="table table-responsive table-bordered table-striped">
                <thead>
                  <tr>
                    <th style="min-width: 10rem">Product ID</th>
                    <th style="min-width: 20rem">Title</th>
                    <th style="min-width: 20rem">Detail</th>
                    <th style="min-width: 7rem">Min Pax</th>
                    <th style="min-width: 7rem">Max Pax</th>
                    <th style="min-width: 40rem">SKUS</th>
                    <th style="min-width: 10rem; text-align: center">Extra Info</th>
                    <th style="min-width: 10rem; text-align: center">Action</th>
                  </tr>
                </thead>
                <tbody v-if="isLoading">
                  <tr>
                    <td colspan="8">
                      <div>Loading...</div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else-if="form.activity !== null">
                  <tr v-for="(product, index) in form.activity.products" :key="index">
                    <td style="text-align: center">
                      <strong>{{ product.product_id }}</strong>
                    </td>
                    <td>{{ product.title }}</td>
                    <td><span style="word-break: break-word"><pre>{{ product.detail }}</pre></span></td>
                    <td style="text-align: center">
                      {{product.product_min_pax}}
                    </td>
                    <td style="text-align: center">
                      {{product.product_max_pax}}
                    </td>
                    <td>
                      <table width="100%">
                        <tbody>
                          <tr v-for="(sku, index) in product.skus" :key="`sku-${index}`">
                            <td>
                              <strong>{{ sku.sku_id }}</strong> - {{ sku.title }} (<strong>Min</strong>: {{sku.sku_min_pax}} <strong>Max</strong>: {{sku.sku_max_pax}})
                              <span v-if="sku.required" style="color:red;">Required</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                    <td style="text-align: center">
                      <span v-if="checkExtraInfo(product.extra_info)" class="label label-danger">Required</span>
                      <span v-else class="label label-info">Not Required</span>
                    </td>
                    <td style="text-align: center">
                      <a class="btn btn-success btn-xs"
                        @click.prevent="showSchedule(product.product_id, product.title)">
                        Get Schedules
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="8">
                      <div>Product data failed to load</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="box-footer">
            <div class="pull-right">
              <a class="btn btn-default "
                @click.prevent="back">
                Back
              </a>
            </div>
          </div>
        </div>

        <transition name="slideDown">
          <modal :title="`${form.activity.title} - ${modal.title}`" v-if="show.schedule">
            <!-- <div class="col-md-12"> -->
              <div class="row">
                <div class="col-md-12"  v-if="show.time_slot">
                  <span class="label label-danger">Warning!</span> This product need time slot!<br>
                </div>
                <div class="col-md-12" style="margin-bottom: 10px;">
                  <h4>Schedules</h4>
                  <div class="row">
                    <label class="control-label col-md-2">
                      Date From
                    </label>
                    <div class="col-md-8">
                      <datepicker
                        v-model="form.date"
                        :disabled="configs.datepicker.disabled"
                        format="dd MMMM yyyy"
                        input-class="form-control"
                        placeholder="Schedule will appear max for next 30 days"
                        name="date">
                      </datepicker>
                    </div>
                    <div class="col-md-2">
                      <button class="btn btn-primary" @click.prevent="getSchedules(form.date)">Check</button>
                    </div>
                  </div>
                </div>
                <div class="col-md-12" v-if="form.schedules">
                  <div class="schedule-wrapper" v-if="!form.schedules.error.code">
                    <span class="schedule-item"
                      v-for="index in schedule_diff"
                      :key="`schedule-item-${index}`">
                        <div class="title">
                          {{ getDate(index) }}
                        </div>
                        <div class="body">
                          <div class="item" v-for="(schedule, idx) in checkSchedule(getDate(index))" :key="`sku-inventory-${idx}`">
                            {{ schedule.sku_id }}
                          </div>
                        </div>
                    </span>

                    <div class="col-md-12">
                      <div class="row">
                        <h4>Prices</h4>
                        <div class="table-responsive" style="overflow: unset;">
                          <table id="table" class="table table-bordered table-striped" width="100%">
                            <thead>
                              <tr>
                                <th style="width: 15em">SKU ID</th>
                                <th>Title</th>
                                <th>Price</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(sku, idx) in form.schedules.skus" :key="`price-${idx}`">
                                <td><strong>{{ sku.sku_id }}</strong></td>
                                <td>{{ sku.title }}</td>
                                <td>{{ sku.price }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12" v-else>Error {{ form.schedules.error.message }}</div>
                </div>
                <div  class="col-md-12" v-else>
                  No data found
                </div>
              </div>
            <!-- </div> -->
          </modal>
        </transition>
      </section>
    </div>
</template>


<script>
import moment from 'moment';
import { find } from 'lodash';
import Modal from '@/components/modules/common/Modal';
import Datepicker from 'vuejs-datepicker';
import Common from '@/mixins/Common';

export default {
  name: 'KlookView',

  mixins: [Common],

  data() {
    return {
      isLoading: false,
      need_extra_info: true,
      guidelines: [],
      usages: [],
      schedule_diff: 0,
      start_date: null,
      modal: {
        title: null,
        product: null,
      },
      form: {
        activity: null,
        schedules: null,
        date: null,
      },
      show: {
        schedule: false,
        time_slot: false,
      },
      configs: {
        datepicker: {
          disabled: {
            to: moment().subtract(1, 'd').toDate(),
          },
        },
      },
    };
  },

  components: {
    Modal,
    Datepicker,
  },

  methods: {
    back() {
      this.$router.go(-1);
    },

    showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },

    closeModals() {
      document.body.classList.remove('locked');
      Object.keys(this.show).forEach((modal) => {
        this.show[modal] = false;
      });
    },

    fetch() {
      this.isLoading = true;
      this.form.date = moment().add(1, 'd').format(this.config.date.iso);
      this.axios.get(`/klook/activities/${this.$route.params.id}`)
      .then((response) => {
        const { data } = response;
        if (data.success === true) {
          const activity = data.activity;
          this.form.activity = activity;
          this.guidelines = JSON.parse(this.form.activity.giudelines);
          this.usages = JSON.parse(this.form.activity.usage);
        } else {
          console.log('Status', false);
        }
      })
      .catch((error) => {
        console.log('Fetch country error', error);
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    checkExtraInfo(extrainfo) {
      if (!extrainfo) return false;

      const { general, travelers } = extrainfo;

      if (!general && !travelers) {
        return false;
      }
      return true;
    },

    getSchedules(date, format) {
      const startDate = moment(date, format).format(this.config.date.iso);
      const endDate = moment(date, format).add(30, 'd').format(this.config.date.iso);
      const params = {
        lang: 'id_ID',
        start_date: startDate,
        end_date: endDate,
      };

      this.start_date = startDate;
      this.schedule_diff = moment(endDate).diff(startDate, 'd');
      this.axios.get(`/klook/${this.modal.product}/schedules`, { params })
      .then((response) => {
        const { data } = response;
        this.form.schedules = data;

        this.checkTimeslot();
      })
      .catch((error) => {
        console.log('Fetch schedule error', error);
      });
    },

    showSchedule(product, title) {
      this.modal.title = title;
      this.modal.product = product;

      this.getSchedules(moment().add(1, 'd'), this.config.date.iso);
      this.showModal('schedule');
    },

    getDate(index) {
      let date = moment(this.start_date).format(this.config.date.simple);

      if (index !== 1) {
        date = moment(this.start_date).add(index - 1, 'd').format(this.config.date.simple);
      }

      return date;
    },

    checkSchedule(date) {
      const newDate = moment(date, this.config.date.simple).format(this.config.date.iso);
      const result = find(this.form.schedules.schedules, { date: newDate });

      if (result) {
        return result.sku_inventory;
      }

      return false;
    },

    checkTimeslot() {
      let count = 0;
      this.show.time_slot = false;

      this.form.schedules.schedules.forEach((schedule) => {
        if (schedule.times_slot.length > 0) {
          if (schedule.times_slot !== '00:00') {
            count += 1;
          }
        }
      });

      if (count > 0) this.show.time_slot = true;
    },

    nReplace(str) {
      let newStr = str.replace('\r\n', '<br>');

      newStr = newStr.replace(/_/g, ' ');

      return newStr;
    },
  },

  mounted() {
    this.fetch();
  },
};
</script>

<style lang="scss" scoped>
  pre {
    background-color: transparent;
    border: none;
    font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin-bottom: 0;
    padding-top: 0;
    word-wrap: break-word;
  }

  .schedule-wrapper {
    display: flex;
    flex-wrap: wrap;

    .schedule-item {
      width: calc(100% / 5);
      min-height: 8rem;
      border: 1px solid #ebebeb;

      .title {
        padding: .25rem;
        background-color: #223f77;
        font-weight: bolder;
        color: white;
        text-align: center;
      }

      .body {
        padding: .5rem;

        .item {
          font-size: 80%;
          border: 1px solid #cccccc;
          border-radius: 25px;
          text-align: center;
          margin-bottom: 5px;
          background-color:  #eeeeee;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/klook/View.vue